"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

/**
 * This component is needed to prevent children reloading
 */
var ChildrenWrapper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ChildrenWrapper, _React$Component);

  function ChildrenWrapper() {
    (0, _classCallCheck2.default)(this, ChildrenWrapper);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ChildrenWrapper).apply(this, arguments));
  }

  (0, _createClass2.default)(ChildrenWrapper, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.isLoading;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);
  return ChildrenWrapper;
}(_react.default.Component);

ChildrenWrapper.propTypes = {
  /**
   * children: Сhildren сomponents
   */
  children: _propTypes.default.node,

  /**
   * isLoading: Indicates loading process
   */
  isLoading: _propTypes.default.bool
};
ChildrenWrapper.defaultProps = {
  isLoading: false
};
var _default = ChildrenWrapper;
exports.default = _default;